/**
 * Route guards. <RequireAuth> blocks anonymous access (redirect to /login while
 * remembering the target). <RequireRole> additionally enforces RBAC, showing a clean
 * 403 rather than redirecting (the user IS signed in, just not permitted).
 */
import { Navigate, useLocation } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { useAuth } from './AuthProvider.jsx';

export function BootScreen() {
  return (
    <div
      style={{
        height: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--bg)',
        color: 'var(--text-muted)',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div className="usmehar-boot-spinner" />
        <p style={{ marginTop: 16, fontSize: '0.9rem' }}>Restoring your session…</p>
      </div>
    </div>
  );
}

export function RequireAuth({ children }) {
  const { status, isAuthed } = useAuth();
  const location = useLocation();
  if (status === 'booting') return <BootScreen />;
  if (!isAuthed) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

export function RequireRole({ roles, children }) {
  const { hasRole } = useAuth();
  if (!hasRole(roles)) {
    return (
      <div style={{ padding: '64px 24px', textAlign: 'center', color: 'var(--text-muted)' }}>
        <ShieldX size={40} style={{ color: 'var(--danger)' }} />
        <h2 style={{ marginTop: 16 }}>Not permitted</h2>
        <p>Your role doesn’t have access to this area.</p>
      </div>
    );
  }
  return children;
}

export default RequireAuth;
